import moment from "moment/moment";
import React, { Component } from 'react'
import matchSorter from 'match-sorter'
import { Header, Icon , Button, Divider, Modal} from 'semantic-ui-react'

import {getLicenseId, getLicenseName} from '../../common/licenseHelper'
import ReactTable from 'react-table'

import LicenseAccessAdd from '../../containers/LicenseAccess/LicenseAccessAdd';
import LicenseAccessEdit from '../../containers/LicenseAccess/LicenseAccessEdit';
import LicenseAccessDel from '../../containers/LicenseAccess/LicenseAccessDel';


class LicenseAccessTable extends Component {
    constructor(props) {
        super(props)
        this.columns = [
            {
                Header: "Full name",
                accessor: "fullname",
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["fullname"]}),
                filterAll: true


            },
            {
                Header: "Email",
                accessor: "email",
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["email"]}),
                filterAll: true

            },
            {
                Header: "Company",
                accessor: "company",
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["company"]}),
                filterAll: true

            },

            {
                Header: "License Code",
                accessor: "license_code",
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["license_code"]}),
                filterAll: true,
                width: 140,

            },

            {
                Header: "Product",
                id: 'product_code',
                accessor: d => getLicenseName(d.product_code),
                width:150

            },

            {
                Header: "Num",
                id: 'num_licenses',
                accessor: 'num_licenses',
                //accessor: d => getLicenseName(d.product_code),
                width:70

            },


            {
                Header: "Expire date",
                id: 'expire_date',
                accessor: (row) => moment(row.expire_date, "DD.MM.YYYY").format("YYYY.MM.DD").toString(),

                width:100,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["expire_date"], threshold: matchSorter.rankings.CONTAINS}),
                filterAll: true


            },

            {
                Header: "Last updated",
                id: "create_date",
                accessor: (row) => moment(row.create_date, "DD.MM.YYYY HH:mm:ss").format("YYYY.MM.DD HH:mm:ss").toString(),
                width:150,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["create_date"], threshold: matchSorter.rankings.CONTAINS}),
                filterAll: true

            },

            {
                Header: "Action",
                accessor: "id",
                width:80,
                Filter: () => <React.Fragment></React.Fragment>,
                Cell: ({row,value}) => (
                    <div>
                        <LicenseAccessEdit rowId={value} userId={row.email} data={{
                            ...row,
                            license_type: getLicenseId(row.product_code),
                            email_user: row.email,
                            // Older records predate the num_licenses column and store null.
                            // A blank value fails the required validation and locks the
                            // "Update license" button, so fall back to 1 (the Add default).
                            num_licenses: (row.num_licenses === null || row.num_licenses === undefined || row.num_licenses === '')
                                ? 1 : row.num_licenses

                        }}/>
                        <LicenseAccessDel rowId={value} userId={row.email} />
                    </div>
                )

            }
        ];

    }

    render() {
        const {data, emails} = this.props;
        return (
            <ReactTable
                filterable
                data={data}
                columns={this.columns}
                defaultFilterMethod={(filter, row) =>
                    row[filter.id] !== undefined &&
                    String(row[filter.id]).toLowerCase().includes(String(filter.value).toLowerCase())}
                defaultSorted={[
                    {
                        id: "create_date",
                        desc:true
                    }
                ]}
                defaultPageSize={20}
                className="-striped -highlight"/>
        )
    }
}



export default class LicenseAccessList extends Component {

    constructor(props) {
        super(props);

    }
    componentWillMount() {
        this.setState({
            open : false
        });
    }

    show = () =>  this.setState({ open: true })
    close = () => this.setState({ open: false })

    render() {
        const {data, emails, isAdmin} = this.props;
        const {open} = this.state;
        return (
            <React.Fragment>

                <Header as='h2'>
                    <Icon name='user'/>
                    <Header.Content>
                        License Management
                    </Header.Content>
                </Header>
                <Button compact onClick={this.show} disabled={!isAdmin}>
                    <Header as='h4'>
                        <Icon.Group size='large'>
                            <Icon name='user'/>
                            <Icon corner name='plus'/>
                        </Icon.Group>
                        Add new license
                    </Header>
                </Button>
                <Divider hidden/>

                <LicenseAccessAdd open={open} onClose={this.close}
                         initialValues={{
                             expire_date: moment().add(1, 'Y'),
                             license_type: 99,
                             num_licenses: 1,
                             email_user:''
                         }}/>

                <LicenseAccessTable data={data} emails={emails}/>

            </React.Fragment>
        )

    }
}
